import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as taskActions from "../../actions/taskActions";
import * as modalActions from "../../actions/modalActions";

import TaskList from "./TaskList";
import HeaderWrapper from "../common/HeaderWrapper";
import TaskForm from "./TaskForm";
import Modal from "../common/Modal";

const TaskPage = ({ tasks, task, savingTask, actions }) => {
  const [state, setState] = useState({
    open: false,
    adding: false,
    search: ""
  });

  useEffect(() => {
    if (!tasks.length) actions.loadTasks();
  }, [actions, tasks.length]);

  const onClickAdd = () => {
    actions.showModalSuccess("taskModal");
    setState((prev) => ({ ...prev, adding: true }));
  };

  const onClickEdit = (item) => {
    actions.getTask(item.id);
    actions.showModalSuccess("taskModal");
  };

  const handleAdd = (service) => {
    actions.createTask(service);
    setState((prev) => ({ ...prev, adding: false }));
  };

  const handleEditTask = async (item) => {
    actions.updateTask(item);
  };

  return (
    <>
      <HeaderWrapper
        breadcrumbs={[{ label: "Tasks" }, { label: "Task Descriptions" }]}
        onClickAdd={onClickAdd}
      />
      <div className="content-wrapper">
        <TaskList tasks={tasks} onClickEdit={onClickEdit} />
      </div>
      <Modal
        id="taskModal"
        title="Task Info"
        body={
          <TaskForm
            onEditTask={handleEditTask}
            saving={savingTask}
            task={task}
            adding={state.adding}
            onAddTask={handleAdd}
            onCancel={actions.hideModal}
          />
        }
        close={actions.hideModal}
      />
    </>
  );
};

TaskPage.propTypes = {
  actions: PropTypes.object,
  savingTask: PropTypes.bool,
  tasks: PropTypes.array.isRequired,
  task: PropTypes.object.isRequired
};

function mapStatesToProps(state) {
  return {
    task: state.reducers.task,
    tasks: state.reducers.tasks,
    savingTask: state.reducers.savingTask
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...taskActions,
        ...modalActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(TaskPage);
